// TODO: избавиться от дефолтного импорта
export default function makeTag(tagName, source) {
  const tag = document.createElement(tagName);
  tag.setAttribute('src', source);

  return tag;
}

/**
 * @param {String} HTML, представляющий один элемент
 * @return {Element}
 */
export function htmlToElement(html) {
  let div = document.createElement('div');
  div.innerHTML = html.trim();

  let res = div.firstElementChild;
  div.remove();

  return res;
}

/**
 * @param {String} HTML, представляющий один элемент
 * @param {String} название аттрибута, значение которого необходимо получить
 * @return {String}
 */
export function getAttributeFromHtml(html, attr) {
  let elem = htmlToElement(html);
  let res = elem.getAttribute(attr);

  elem.remove();

  return res;
}
